import React, { useEffect } from "react";
import PhanTrang from "components/CommonComponent/PhanTrang";
import { ContentTable } from "./ContentTable";

import { useSelector, useDispatch } from "react-redux";
import {
  getListCongNoThanhLy,
  updateDataSearch,
} from "../../actions/CongNoThanhLy";
import { formatNumber } from "utils/currencyFormat";

export const TableCongNoThanhLy = ({ quyenThanhToan, quyenXoa }) => {
  const dispatch = useDispatch();
  const listCongNoFull = useSelector((state) => state.listCongNoThanhLyFull); //listTaiSanFul dinh nghia o rootreducer
  const dataSearch = useSelector((state) => state.dataSearchCongNoThanhLy); //dataSearchTaiSan dinh nghia o rootreducer

  useEffect(() => {
    dispatch(getListCongNoThanhLy(dataSearch));
  }, []);

  const loadTaiSan = () => {
    getListCongNoThanhLy(dataSearch);
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }; // set lên đầu page ví dụ khi phân trang

  const handlePageChange = (pageNumber) => {
    dataSearch.pageIndex = pageNumber;
    dispatch(
      updateDataSearch({
        ...dataSearch,
        pageIndex: pageNumber,
      })
    );
    dispatch(getListCongNoThanhLy(dataSearch));
    loadTaiSan(dataSearch);
    //setpageNumber(pageNumber);
  };
  const handlePageSizeChange = (pageSize) => {
    const data = { ...dataSearch, pageSize, pageIndex: 1 };
    dispatch(updateDataSearch(data));
    dispatch(getListCongNoThanhLy(data));
    loadTaiSan();
  };
  const TotalQuantity = listCongNoFull.TotalQuantity;

  return (
    <>
      <div
        className="card border-light mb-1 card-v2"
        style={{
          marginLeft: "15px",
          marginRight: "15px",
        }}
      >
        <div className="card-body card-body-v2">
          <div className="Left808x200 Table-main-new">
            <div className="loading-page1">
              <div
                className={
                  "loader loader-default " +
                  (listCongNoFull.getListCongNoThanhLyLoading
                    ? "is-active"
                    : "")
                }
              ></div>
            </div>
            <div className="table-mobile  table-mobile-hover">
              <div className="custom-table-wrapper">
                <div className="table-headers">
                  <div className="custom-table-header flex-basis-5 flex-basis-6-sm">
                    <p className="text-center">
                      STT
                      <br />{" "}
                      <span className="color-do-bold">
                        [ {listCongNoFull.TotalQuantity} ]
                      </span>
                    </p>
                  </div>
                  <div className="custom-table-header flex-basis-10 flex-basis-12-2-sm">
                    <p className="text-center color7-bold">Mã</p>
                  </div>
                  <div className="custom-table-header flex-basis-12 flex-basis-11-sm">
                    <p className="color7-bold">Khách hàng</p>
                  </div>
                  <div className="custom-table-header flex-basis-15 flex-basis-11-6-sm">
                    <p className="color7-bold">Tên tài sản</p>
                  </div>
                  <div className="custom-table-header flex-basis-11 flex-basis-13-sm">
                    <p className="text-center color7-bold">Mã hợp đồng</p>
                  </div>
                  <div className="custom-table-header flex-basis-12 flex-basis-12-8-sm">
                    <p className="text-right color7-bold">
                      Tiền thanh lý
                      <br />
                      <span className="color-do-bold">
                        {formatNumber(listCongNoFull.TongTienThu)}
                      </span>
                    </p>
                  </div>
                  <div className="custom-table-header flex-basis-12 flex-basis-12-8-sm">
                    <p className="text-right color7-bold">
                      Đã trả
                      <br />
                      <span className="color-xanh-bold">
                        {formatNumber(listCongNoFull.TongTienDaTra)}
                      </span>
                    </p>
                  </div>
                  <div className="custom-table-header flex-basis-12 flex-basis-12-sm">
                    <p className="text-right">
                      Còn nợ
                      <br />
                      <span className="color-cam-bold">
                        {formatNumber(listCongNoFull.TongTienConNo)}
                      </span>
                    </p>
                  </div>
                  <div className="custom-table-header flex-basis-11 flex-basis-8-6-sm">
                    <p className="tab-header color7-bold">Chức năng</p>
                  </div>
                </div>

                <div className="custom-table-body">
                  <ContentTable
                    listCongNoFull={listCongNoFull.List}
                    quyenThanhToan={quyenThanhToan}
                    quyenXoa={quyenXoa}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="card border-light mb-3 card-v2"
        style={{
          marginLeft: "15px",
          marginRight: "15px",
        }}
      >
        <div className="card-body card-body-v2">
          <PhanTrang
            pageIndex={dataSearch.pageIndex}
            pageSize={dataSearch.pageSize}
            totalCount={TotalQuantity}
            onPageChange={handlePageChange}
            onPageSizeChange={handlePageSizeChange}
          />
        </div>
      </div>
    </>
  );
};
